const LandingPageMetricRow = ({ text, value }) => (
  <div className="w-1/2 lg:w-full py-6 text-center">
    {text} <br />
    <span className="font-extrabold font-arialb text-4xl">{value}</span>
  </div>
);

export default LandingPageMetricRow;